




































































import { Component, Vue} from 'vue-property-decorator'
import { setSessionStorage } from '../../../store/src/utils/index'
@Component
export default class Login extends Vue {
	private reportFormId: string = 'DFHZ_10001'
	private gridData: any = []
	private hidecCols: string = ''
	private sumCol: any = {}
	private dateValue: any = []
	private billState: string = ''
	private settingCols: any = []
	private filterFormData: any = {
		goodsName: '',
		organName: [],
		billTypeId: [],
		billState: ['11'],
		groupByOrgan: true,
		groupByHouse: false
	}
	private options: any = []
	private billTypeOptions: any = [
		{
			id: '0450_0030_0400',
			name: '门店自采订单'
		},
		{
			id: '0450_0030_0300',
			name: '门店直配订单'
		},
		{
			id: '0450_0030_0600',
			name: '中心采购订单'
		}
	]
	private billStateOptions: any = [
			{
			stateValue: '10',
			stateFont: '未处理'
		}, {
			stateValue: '11',
			stateFont: '待发货'
		}, {
			stateValue: '12',
			stateFont: '已发货'
		}, {
			stateValue: '13',
			stateFont: '已收货'
		}, {
			stateValue: '14',
			stateFont: '已收货已确认'
		}, {
			stateValue: '20',
			stateFont: '退货未确认'
		}, {
			stateValue: '21',
			stateFont: '退货已确认'
		}
	]
	private onChangeColData (hideCol: string) {
		this.hidecCols = hideCol
	}
	private async onSearch () {
		const searchFilter = await this.searchFilter('1')
		const params = {
			filters: {rules: this.getFiltersParams().filtersParams},
			ediExportHideCols: '1'
		}
		await this.initTableData(params)
		await this.searchHandler(searchFilter)
	}
	private searchFilter (ediExportParams?: string) {
		return new Promise((resolve: any) => {
			const settingMenuParams = this.settingCols.map((item) => {
				return item.prop
			})
			const params = {
				filters: {rules: this.getFiltersParams().filtersParams},
				rows: 30,
				page: 1,
				validcols: settingMenuParams.join(','),
				ediExportHideCols: ediExportParams
			}
			resolve(params)
		})
	}
	private searchHandler (params) {
		return new Promise((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/reportDateController/getDFHZ10001DataChoose',
				data: params
			}).then((res: any) => {
				this.setGridData(res)
				resolve()
			})
		})
	}
	private onExport () {
		this.exportFun()
	}
	private async exportFun () {
		const hideCols = this.hidecCols
		const searchFilter = await this.searchFilter(hideCols)
		const params = {
			filters: {rules: this.getFiltersParams().filtersParams},
			ediExportHideCols: ''
		}
		await this.initTableData(params)
		const searchHandler = await this.searchHandler(searchFilter)
		await this.exportHandler(searchHandler)
	}
	private exportHandler (params) {
		window.open('/cldEdi/reportDateController/exportEdiDataCommon.do?exportType=4')
	}
	private onSortChange ({ prop, order }) {
		const settingMenuParams = this.settingCols.map((item) => {
			return item.prop
		})
		const params = {
			filters: {rules: this.getFiltersParams().filtersParams},
			rows: 30,
			page: 1,
			validcols: settingMenuParams.join(','),
			sord: prop === null ? null : order === 'ascending' ? 'asc' : 'desc',
			sidx: prop
		}
		return new Promise((resolve: any) => {
			return (this as any).$fxHttp.requestPost({
				url: '/reportDateController/getDFHZ10001DataChoose',
				data: params,
				loading: true
			}).then((res: any) => {
				this.setGridData(res)
				resolve()
			})
		})
	}
	private setGridData (gridObj) {
		this.gridData = gridObj.currentData || []
		this.sumCol = gridObj.userdata || {}
	}
	private created () {
		setSessionStorage('titleLabel', '货品汇总表')
		this.initFilters()
		this.initTableData()
		this.initOrganFilterData()
	}
	private initOrganFilterData () {
		return (this as any).$fxHttp.requestPost({
			url: '/reportDateController/getDFHZ10001ConfigOrgan'
		}).then((res: any) => {
			this.options = res
			return Promise.resolve()
		})
	}
	private initTableData (params?: any) {
		return (this as any).$fxHttp.requestPost({
			url: '/reportDateController/getDFHZ10001ConfigChoose',
			data: params
		}).then((res: any) => {
			this.settingCols = res.currentData
			return Promise.resolve()
		})
	}
	private initFilters () {
		this.dateValue = [(this as any).$fxCommon.orderFilterStartDate(), (this as any).$fxCommon.orderFilterEndDate()]
	}
	private getFiltersParams () {
		const filtersParams = [] as any
		if (this.filterFormData.goodsName) {
			const goodsName = { field: 'goods_name', data: this.filterFormData.goodsName, op: 'cn' }
			filtersParams.push(goodsName)
		}
		if (this.filterFormData.organName.length) {
			const organName = { field: 'organ_name', data: this.filterFormData.organName, op: 'cn' }
			filtersParams.push(organName)
		}
		if (this.filterFormData.billTypeId.length) {
			const billTypeId = { field: 'billTypeId', data: this.filterFormData.billTypeId, op: 'cn' }
			filtersParams.push(billTypeId)
		}
		if (this.filterFormData.billState.length) {
			const billState = { field: 'billState', data: this.filterFormData.billState, op: 'cn' }
			filtersParams.push(billState)
		}
		const groupByOrgan = { field: 'groupByOrgan', data: this.filterFormData.groupByOrgan, op: 'eq'}
		filtersParams.push(groupByOrgan)
		const groupByHouse = { field: 'groupByHouse', data: this.filterFormData.groupByHouse, op: 'eq'}
		filtersParams.push(groupByHouse)
		if (this.dateValue === '' ||
			this.dateValue === null ||
			this.dateValue === undefined) {
			filtersParams.push(
				{ field: 'from_date', data: `${(this as any).$fxCommon.orderFilterStartDate()} 00:00`, op: 'ge' },
				{ field: 'from_date', data: `${(this as any).$fxCommon.orderFilterEndDate()} 23:59`, op: 'le' }
			)
		} else {
			filtersParams.push(
				{ field: 'from_date', data: `${this.dateValue[0]} 00:00`, op: 'ge' },
				{ field: 'from_date', data: `${this.dateValue[1]} 23:59`, op: 'le' }
			)
		}
		return {
			filtersParams
		}
	}
}
